<template>
	<template-base class="containerCard">
		<EditProduct
			v-if="modalEdit"
			:productData="productSelected"
			@closeModal="closeModal"
			@findProduct="findProduct"
			:showTaxe="possuiPermissao('GER_V_TRIBUTO')"
		/>
		<div>
			<div v-if="linhas.length && !showPaginationOnlyFooter" class="head-row mb-2 width-pagination-items">
				<div class="text-head-row width-pagination">
					<label class="text-head-row ml-0">
						Resultado {{ pagination.offset + 1 }}-{{ pagination.offset + linhas.length }} de {{ pagination.count }}
					</label>
					<b-pagination
						class="mr-0 mb-2"
						id="page"
						v-model="currentPage"
						:total-rows="pagination.count"
						:per-page="pagination.limit.value"
					></b-pagination>
				</div>
				<b-form
					class="text-head-row width-pagination">
					<label class="text-head-row ml-0">
						Itens por página
					</label>
					<b-form-select
						class="mr-0 mb-2"
						v-model="pagination.limit.value"
						name="itens-por-pagina"
						:options="optionsItensPorPag"
						@input="changeItensByPage()"
						:disabled="loading"
					/>
				</b-form>
			</div>
		</div>
		<div>
			<DataTable v-if="!isMobile"
				class="data-table"
				:loading="loading"
				:colunas="colunas"
				:linhas="linhas"
				:errMsg="errMsg"
				:nofilters="true"
				name="product"
				:hasPagination="true"
				:noedit="true"
				:acoes="true"
				:permissaoEdit="possuiPermissao('GER_U_PRODUTOS')"
				:permissaoDelete="possuiPermissao('GER_D_PRODUTOS')"
				@clickDelete="confirmDelete"
				@clickEdit="showEdit"
				@clickSortTableBy="(v) => sortTableBy(v)"
				:state="{
					sortBy: sortTable.sortBy,
					sortAsc: sortTable.order === 1,
					query: ''
				}"
				:async="true"
				:alignColumns="alignColumnsTable"
				@state-change="(state) => newSearch(state)"
				@clickBtnAdd="showEdit"
				:nosearch="false"
				:hideBtnAdd="!possuiPermissao('GER_I_PRODUTOS')"
			/>
			<CardTransaction v-else
				:loading="loading"
				:colunas="colunas"
				:linhas="linhas"
				:errMsg="errMsg"
				:acoes="true"
				:permissaoEdit="possuiPermissao('GER_U_PRODUTOS')"
				:permissaoDelete="possuiPermissao('GER_D_PRODUTOS')"
				@clickDelete="confirmDelete"
				@clickEdit="showEdit"
				:selectItem="false"
				:globalAcoes="false"
				:colsDataCard="colsDataCard"
				:details="false"
				:showSelectItem="false"
				@state-change="(state) => newSearch(state)"
				@clickBtnAdd="showEdit"
				:nosearch="false"
				:hideBtnAdd="!possuiPermissao('GER_I_PRODUTOS')"
			/>
		</div>
		<div v-if="linhas.length && showPaginationOnlyFooter" class="text-head-row d-block">
			<section style="display: flex; justify-content: center;">
				<b-pagination
					id="page"
					class="mb-1"
					v-model="currentPage"
					:total-rows="pagination.count"
					:per-page="pagination.limit.value"
				></b-pagination>
			</section>
			<section style="display: flex; justify-content: center;">
				<label class="text-head-row" style="width: auto;">
					Resultado {{ pagination.offset + 1 }}-{{ pagination.offset + linhas.length }} de {{ pagination.count }}
				</label>
			</section>
		</div>
	</template-base>
</template>

<script>
	import DataTable from "@/components/DataTable";
	import TemplateBase from "@/templates/Base";

	import { possuiPermissao } from "../../helpers/permissions";
	import { ProductService } from "../../services/product";
	import { numberFormatted } from "@/helpers/common";
	import CardTransaction from "@/components/CardTransaction.vue";
	import { mapState } from "vuex";
	import EditProduct from "./EditProduct.vue";

	export default {
		components: {
			TemplateBase,
			DataTable,
			CardTransaction,
			EditProduct
		},
		computed: mapState(["usuarioLogado"]),

		inject: ["parentValidator"],

		data () {
			return {
				product: [],
				linhas: [],
				loading: true,
				productSelected: {},
				modalEdit: false,
				showComposed: false,
				sale1: false,
				sale2: false,
				sale3: true,

				productService: new ProductService(),

				errMsg: "Nenhum produto cadastrado!",
				colunas: [
					"Descrição",
					"Tipo Produto",
					"Quantidade",
					"Preço de Revendedor",
					"Preço de Atacado",
					"Preço de Varejo",
					"Referência"

				],
				alignColumnsTable: [
					"left",
					"left",
					"right",
					"right",
					"right",
					"right",
					"left"
				],
				pagination: {
					count: 0,
					page: 1,
					offset: 0,
					limit: {
						value: 50
					},
					pages: 1
				},
				currentPage: 1,
				optionsItensPorPag: [
					{
						value: 5,
						text: "5 Items"
					},
					{
						value: 25,
						text: "25 Items"
					},
					{
						value: 50,
						text: "50 Items"
					},
					{
						value: 75,
						text: "75 Items"
					},
					{
						value: 100,
						text: "100 Items"
					}
				],
				possuiPermissao,
				sortTable: {
					sortBy: 0,
					order: 1,
					query: ""
				},
				isMobile: false,
				colsDataCard: {
					0: {
						idx: 0,
						label: "Descrição",
						textAlign: "left",
						cols: 8,
						visible: true
					},
					1: {
						idx: 1,
						label: "Tipo Produto",
						textAlign: "left",
						cols: 4,
						visible: true
					},
					2: {
						idx: 2,
						label: "Quantidade",
						textAlign: "center",
						cols: 3,
						visible: true
					},
					3: {
						idx: 3,
						label: "Preço de Revendedor",
						textAlign: "right",
						cols: 3,
						visible: true
					},
					4: {
						idx: 4,
						label: "Preço de Atacado",
						textAlign: "right",
						cols: 3,
						visible: true
					},
					5: {
						idx: 5,
						label: "Preço de Varejo",
						textAlign: "right",
						cols: 3,
						visible: true
					},
					6: {
						idx: 6,
						label: "Referência",
						textAlign: "left",
						cols: 12,
						visible: true
					},
					7: {
						idx: null,
						label: "",
						textAlign: "",
						cols: 0,
						visible: false
					}
				},
				showPaginationOnlyFooter: true
			};
		},

		watch: {
			currentPage () {
				this.changePage(this.currentPage);
			}
		},

		created () {
			this.$validator = this.parentValidator;
		},

		async mounted () {
			this.showComposed = Boolean(this.usuarioLogado.config.showProductComposed);
			this.sale1 = Boolean(this.usuarioLogado.config.sale1);
			this.sale2 = Boolean(this.usuarioLogado.config.sale2);
			this.sale3 = Boolean(this.usuarioLogado.config.sale3);
			this.checkIfMobile();
			window.addEventListener("resize", this.checkIfMobile);

			await this.findProduct();
		},

		beforeDestroy () {
			window.removeEventListener("resize", this.checkIfMobile);
		},

		methods: {
			checkIfMobile	() {
				this.isMobile = window.innerWidth <= 768;
			},

			sortTableBy (v) {
				this.sortTable = v;
				this.findProduct();
			},

			changePage () {
				this.pagination.page = this.currentPage;
				this.findProduct();
			},

			changeItensByPage () {
				this.pagination.page = 1;
				this.findProduct();
			},

			async findProduct () {
				this.loading = true;
				const limit = this.pagination.limit.value;
				this.pagination.offset = (this.pagination.page - 1) * limit;
				const offset = this.pagination.offset;
				const sortTable = this.sortTable;

				const result = await this.productService.listProduct({offset, limit, sortTable}) || {};
				this.product = result.rows.map(ele => ele);
				this.linhas = result.rows.reduce((acc, c) => [
					...acc,
					{
						idProduct: c.idProduct,
						cols: [
							c.description,
							c.nameProductClass,
							numberFormatted(c.quantity || "0"),
							numberFormatted(c.sale1 || "0"),
							numberFormatted(c.sale2 || "0"),
							numberFormatted(c.sale3 || "0"),
							c.reference || "-"
						]
					}
				], []);

				this.pagination.count = result.count || 0;
				this.pagination.pages = this.pagination.count > limit ? Math.ceil(this.pagination.count / limit) : 1;
				this.loading = false;
			},

			async showEdit (item_) {
				let item = {};
				if (item_.idProduct)
					[ item ] = this.product.filter(c => c.idProduct === item_.idProduct);

				this.productSelected = item;
				this.modalEdit = true;
			},

			async confirmDelete (item_) {
				const [ item ] = this.product.filter((gu) => gu.idProduct === item_.idProduct);
				const deleteConfirmation = (await this.$swal({
					title: "Excluir",
					text: "Tem certeza que deseja remover o produto?",
					type: "error",
					showCancelButton: true,
					cancelButtonColor: "#A6A8AB",
					confirmButtonColor: "#DD6B55",
					imageWidth: 50,
					imageHeight: 50,
					cancelButtonText: "Não",
					confirmButtonText: "Sim",
					reverseButtons: true
				})).value;

				if (deleteConfirmation)
					this.delete(item.idProduct);
			},

			async delete (idProduct) {
				const config = {
					timeout: 2000,
					showProgressBar: true,
					closeOnClick: true,
					pauseOnHover: true
				};

				this.$snotify.async("Aguarde...", "Apagando", async () => {
					try {
						await this.productService.deleteProduct({idProduct});
						this.findProduct();

						return {
							title: "Sucesso!",
							body: "Produto deletado com sucesso.",
							config
						};
					} catch (error) {
						const msgError = error.response.data.message || "Erro ao tentar deletar o produto!";
						throw {
							title: "Falha!",
							body: msgError,
							config
						};
					}
				});
			},

			newSearch (state) {
				this.sortTable.query = state.query;
				this.findProduct();
			},

			closeModal () {
				this.modalEdit = false;
			}
		}
	};
</script>

<style scoped>
	.border-top-none {
		border-top: none !important;
	}

	.text-conta {
		font-family: 'Roboto Condensed Regular';
		font-size: 20px;
	}

	.toggle-conta {
		/* display: flex; */
		margin-top: 7px;
		/* justify-content: center; */
	}

	label {
		width: 160px;
	}

	.container-head {
		display: flex;
		height: 5rem;
		width: 100%;
	}

	.container-pages {
		display: flex;
		width: 70%;
		margin-top: 1.5rem;
	}

	.containerCard {
		max-width: 90.5%;
	}

	.modal-edicao-label {
		font-family: 'Roboto Condensed Regular';
		font-size: 23px;
	}

	.modal-edicao-input {
		font-family: 'Roboto Condensed Regular';
		font-size: 20px;
	}

	.table-body-detalhe {
		padding: 5px 0;
	}

	.container-add-new-100 {
		width: 100% !important;
	}
</style>
